import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

/**
 * PageLayout — wraps every page with Navbar + main + Footer.
 * Handles top padding to clear the fixed nav and scroll-to-top on route change.
 *
 * Props:
 *   hideFooter: boolean (default false)
 *   mainClassName: string
 */
export const PageLayout = ({ children, hideFooter = false, mainClassName }) => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-bg-base text-white">
      <Navbar />
      <main
        className={`flex-1 pt-16 ${mainClassName || ""}`}
        data-testid="page-main"
      >
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default PageLayout;
